export class User {
  constructor(data = {}) {
    this.id = data.id || null;
    this.username = data.username || "";
    this.firstName = data.firstName || "";
    this.lastName = data.lastName || "";
  }
}
